export const VENUES = {
  conceptScheme: 'venues',
  title: 'Venues',
  highestMinPrice: 37500,
  lowestMinPrice: 25,
  image: {
    altText: 'venue',
    url: 'https://media-api.xogrp.com/images/35d4bde6-15c3-415f-97ec-8bfce636083d',
  },
};
export const ENTERTAINMENT = {
  conceptScheme: 'entertainment',
  title: 'Entertainment',
  highestMinPrice: 5000,
  lowestMinPrice: 12,
  image: {
    altText: 'entertainment',
    url: 'https://media-api.xogrp.com/images/ee8686a2-926a-4e81-bb95-0413649fc427',
  },
};
export const FOOD = {
  conceptScheme: 'food',
  title: 'Caterers',
  highestMinPrice: 5000,
  lowestMinPrice: 12,
  image: {
    altText: 'caterer',
    url: 'https://media-api.xogrp.com/images/34b6f399-4313-4c41-b7a8-8a5535439aee',
  },
};
export const BEVERAGE = {
  conceptScheme: 'beverage',
  title: 'Bartenders',
  highestMinPrice: 700,
  lowestMinPrice: 20,
  image: {
    altText: 'bartender',
    url: 'https://media-api.xogrp.com/images/ecc83ae4-966a-4e87-a284-5e40ac4f8998',
  },
};
const PRIMARY_CONCEPTS = [VENUES, ENTERTAINMENT, FOOD, BEVERAGE];

export default PRIMARY_CONCEPTS;
